<template>
  
</template>

<script>
import api from "../api";

export default {
  data() {
    return {
      pass: null
    };
  },
  mounted() {
    this.getPass();
  },
  methods: { async getPass() {
      try {
        const passId = Number(this.$route.params.passId)
        const pass = await api.getPassById(passId);
        this.pass = pass;
      } catch (e) {
        console.log("Could not get pass");
      }
    }
  }

}
</script>

<style lang="css" scoped>

</style>


// WEBPACK FOOTER //
// src/components/PrintPass.vue